<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title>
          <div>{{ $t("InviteCoApplicant.InviteCoApp") }}</div>
        </v-card-title>
        <v-card outlined>
          <v-card-title>
            <div>{{ $t("InviteCoApplicant.Email") }}</div>
          </v-card-title>
          <div style="margin: 1px 5px 5px 15px">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  :hint="$t('InviteCoApplicant.HintMultiRecipients')"
                  persistent-hint
                  v-model="sendEmailFrm.Recipients"
                >
                  <template slot="label"
                    ><span v-html="$t('InviteCoApplicant.RecipientsR')"
                  /></template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="sendEmailFrm.EmailSubject">
                  <template slot="label"
                    ><span v-html="$t('InviteCoApplicant.SubjectR')"
                  /></template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="ProductionFlag">
              <v-col cols="6" md="3">
                <v-checkbox
                  class="mt-0"
                  input-value="true"
                  value
                  disabled
                  :label="$t('InviteCoApplicant.displayApplicant')"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="6" md="3">
                <v-checkbox
                  class="mt-0"
                  v-model="sendEmailFrm.DisplayAddApplicant"
                  :label="$t('InviteCoApplicant.displayAddApplicant')"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="6" md="3">
                <v-checkbox
                  class="mt-0"
                  v-model="sendEmailFrm.DisplayMortgage"
                  :label="$t('InviteCoApplicant.displayMortgage')"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-textarea
                  v-model="strEmailBody"
                  outlined
                  :label="$t('InviteCoApplicant.EmailBodyR')"
                />
              </v-col>
            </v-row>
            <v-card-actions class="mb-5 mt-10">
              <!-- <v-spacer /> -->
              <v-btn @click="saveSent" color="primary float-left">{{
                $t("InviteCoApplicant.Send")
              }}</v-btn>
            </v-card-actions>
          </div>
        </v-card>

        <v-card outlined>
          <v-card-title>
            <div>{{ $t("InviteCoApplicant.SMS") }}</div>
          </v-card-title>
          <div style="margin: 1px 5px 5px 15px">
            <v-row>
              <v-col cols="12" md="3">
                 <com_phone v-model="PhoneNumberAdd" :label="$t('InviteCoApplicant.MobilePhoneNumber')" :masked="true" />
                <!-- <v-text-field
                  :label="$t('InviteCoApplicant.MobilePhoneNumber')"
                  :masked="true"
                  v-model="PhoneNumberAdd"
                  v-mask="'(###) ###-####'"
                /> -->
                <v-btn
                  :disabled="disableaddbutton"
                  @click="AddPhoneNumber"
                  color="primary float-left"
                  >{{ $t("InviteCoApplicant.Add") }}</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <!-- <v-text-field hint="Multiple phone numbers separated by semicolon." persistent-hint  v-model="sendSMSFrm.Recipients">
                  <template slot="label"><span v-html="$t('InviteCoApplicant.SMSRecipientsR')" /></template>                  
                </v-text-field> -->
                <v-simple-table v-if="this.ListNumber.length > 0">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>{{ $t("InviteCoApplicant.PhoneNumber") }}</th>
                        <th width="50"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="d in ListNumber" v-bind:key="d.Number">
                        <td>{{ d.Number }}</td>
                        <td>
                          <v-btn
                            @click="RemoveNumber(d)"
                            text
                            small
                            color="primary"
                            ><i class="fa fa-times"></i
                          ></v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-textarea
                  v-model="strSMSBody"
                  outlined
                  :label="$t('InviteCoApplicant.EmailBodyR')"
                />
              </v-col>
            </v-row>
            <v-card-actions class="mb-5 mt-10">
              <!-- <v-spacer /> -->
              <v-btn @click="saveSentSMS" color="primary float-left">{{
                $t("InviteCoApplicant.Send")
              }}</v-btn>
            </v-card-actions>
          </div>
        </v-card>

        <v-card outlined>
          <v-card-title>
            <div>{{ $t("InviteCoApplicant.History") }}</div>
          </v-card-title>
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>{{ $t("InviteCoApplicant.InviteMethod") }}</th>
                      <th>{{ $t("InviteCoApplicant.InviteEmailPhone") }}</th>
                      <th>{{ $t("InviteCoApplicant.Status") }}</th>
                      <th>{{ $t("InviteCoApplicant.InviteDate") }}</th>
                      <th width="105"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="d in InvitesHistory" v-bind:key="d.InviteID">
                      <td>{{ d.ContactMethod }}</td>
                      <td>{{ d.Contact }}</td>
                      <td>{{ d.Status }}</td>
                      <td>{{ d.InviteDate }}</td>
                      <td v-if="d.Status == 'Pending'">
                        <v-btn
                          @click="ResendInvitation(d)"
                          text
                          small
                          color="primary"
                          >{{ $t("InviteCoApplicant.Resend") }}</v-btn
                        >
                      </td>
                      <td v-else></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card>
        <v-card-actions class="mb-5 mt-10">
          <v-spacer />
          <v-btn @click="next" color="primary float-right">{{
            $t("labels.Next")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import com_phone from "@/shared/components/phone";
export default {
  components: { drawer,com_phone },
  data() {
    return {
      app: model.appModel(),
      disableaddbutton: true,
      ListNumber: [],
      loadFlag: false,
      InvitesHistory: [],
      mtgAppLinks: [],
      siteID: this.$route.params.siteid,
      userID: null,
      mortgageApplicationID: this.$route.params.appid,
      PhoneNumberAdd: null,
      sendEmailFrm: {
        MtgAppLinkID: null,
        Recipients: null,
        EmailBody: null,
        EmailSubject: null,
        MortgageApplicationID: null,
        DisplayApplicant: false,
        DisplayMortgage: false,
        DisplayAddApplicant: false,
      },
      sendSMSFrm: {
        Recipients: null,
        EmailBody: null,
        EmailSubject: null,
        MortgageApplicationID: null,
      },
      strEmailBody: null,
      strSMSBody: null,
    };
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  computed:{
    ProductionFlag() {
      return process.env.VUE_APP_IsDebug == "true";
    },
  },
  methods: {
    valid() {
      if (!this.sendEmailFrm.Recipients) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("InviteCoApplicant.RequiredRecipients")
        );
        return false;
      }
      if (!this.sendEmailFrm.EmailSubject) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("InviteCoApplicant.RequiredSubject")
        );
        return false;
      }
      if (!this.strEmailBody) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("InviteCoApplicant.RequiredBody")
        );
        return false;
      }
      return true;
    },
    validsms() {
      if (!this.ListNumber.length > 0) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("InviteCoApplicant.RequiredPhoneNumbers")
        );
        return false;
      }
      if (!this.strSMSBody) {
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("InviteCoApplicant.RequiredBody")
        );
        return false;
      }
      return true;
    },
    ResendInvitation(d) {
      if (d.ContactMethod == "Email") {       
        let postData = {
        InviteID: d.InviteID,
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/ReInviteCoApplicant", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {           
            this.$alert(
              this.$t("labels.Success"),
              this.$t("InviteCoApplicant.SuccessSendInviteCoApplicant")
            );
            this.LoadInvites();
          } 
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.ge(err);
        });
      } else {
        var element = {};
        element.Number = d.Contact;
        for (var i = 0; i < this.ListNumber.length; i++) {
          if (this.ListNumber[i].Number == d.Contact) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("labels.PhoneNumberExists")
            );
            return;
          }
        }
        this.ListNumber.push(element);
        this.$alert(
          this.$t("labels.Warning"),
          this.$t("InviteCoApplicant.RescendFillMessage")
        );
      }
    },
    saveSent() {
      if (!this.valid()) return;
      this.loadFlag = true;
      this.sendEmailFrm.MortgageApplicationID = this.mortgageApplicationID;
      this.sendEmailFrm.EmailBody = this.strEmailBody;

      let postData = {
        SendData: this.sendEmailFrm,
        SiteID: this.siteID,
        UserID: this.userID,
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/InviteCoApplicant", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.InviteCoApplicantModalFlag = false;
            this.$alert(
              this.$t("labels.Success"),
              this.$t("InviteCoApplicant.SuccessSendInviteCoApplicant")
            );
            this.LoadInvites();
          } else {
            this.InviteCoApplicantModalFlag = false;
          }
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.ge(err);
        });
    },
    LoadInvites(){
       let postData = {
              MortgageApplicationID: this.mortgageApplicationID,
              UserID: this.userID,
              SiteID: this.siteID,
            };
            dataSvc
              .getHttp()
              .post("/api/LoadInviteCoApplicant", postData)
              .then((res) => {
                this.loadFlag = false;
                this.InvitesHistory = res.data.InvitesHistory;
                this.mtgAppLinks = res.data.MtgAppProfileLinks;
                this.InviteCoApplicantModalFlag = true;
              })
              .catch((err) => {
                this.loadFlag = false;
              });
    },
    AddPhoneNumber() {
      if (this.PhoneNumberAdd != null) {
        // if(this.sendSMSFrm.Recipients == null){
        //   this.sendSMSFrm.Recipients = this.PhoneNumberAdd+";";
        // }else{
        //    this.sendSMSFrm.Recipients = this.sendSMSFrm.Recipients + this.PhoneNumberAdd+";";
        // }
        var element = {};
        element.Number = this.PhoneNumberAdd;
        for (var i = 0; i < this.ListNumber.length; i++) {
          if (this.ListNumber[i].Number == this.PhoneNumberAdd) {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("labels.PhoneNumberExists")
            );
            this.PhoneNumberAdd = null;
            return;
          }
        }
        this.ListNumber.push(element);
        this.PhoneNumberAdd = null;
      }
    },
    RemoveNumber(d) {
      var index = this.ListNumber.findIndex((v) => v.Number === d.Number);
      this.ListNumber.splice(index, 1);
    },
    saveSentSMS() {
      if (!this.validsms()) return;
      this.loadFlag = true;
      this.sendSMSFrm.MortgageApplicationID = this.mortgageApplicationID;
      this.sendSMSFrm.EmailBody = this.strSMSBody;
      this.sendSMSFrm.Recipients = this.ListNumber;

      let postData = {
        SendData: this.sendSMSFrm,
        SiteID: this.siteID,
        UserID: this.userID,
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/InviteCoApplicantSMS", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.InviteCoApplicantModalFlag = false;
            this.$alert(
              this.$t("labels.Success"),
              this.$t("InviteCoApplicant.SuccessSendInviteCoApplicant")
            );
            this.LoadInvites();
          } else {
            this.InviteCoApplicantModalFlag = false;
          }
        })
        .catch((err) => {
          this.loadFlag = false;
          uiSvc.ge(err);
        });
    },
    addCoApplicant() {
      let u =
        "/" +
        this.siteID +
        "/user/" +
        this.mortgageApplicationID +
        "/addCoApplicant";
      this.$router.push(u);
    },
    next() {
      this.$router.push(
        "/" + this.siteID + "/user/" + this.mortgageApplicationID + "/mortgage"
      );
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then((res) => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;
            this.sendEmailFrm.Recipients = null;
            this.sendEmailFrm.EmailSubject = null;
            this.strEmailBody = null;
            this.sendEmailFrm.MtgAppLinkID = null;
            this.loadFlag = true;
            let postData = {
              MortgageApplicationID: this.mortgageApplicationID,
              UserID: this.userID,
              SiteID: this.siteID,
            };
            dataSvc
              .getHttp()
              .post("/api/LoadInviteCoApplicant", postData)
              .then((res) => {
                this.loadFlag = false;
                this.InvitesHistory = res.data.InvitesHistory;
                this.mtgAppLinks = res.data.MtgAppProfileLinks;
                this.InviteCoApplicantModalFlag = true;
              })
              .catch((err) => {
                this.loadFlag = false;
              });
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
  },
  watch: {
    PhoneNumberAdd: {
      handler(n) {
        if (n != null) {
          this.disableaddbutton = false;
        }
        if (n == null || n == "") {
          this.disableaddbutton = true;
        }
      },
    },
  },
};
</script>
